import logo1 from '../assets/img/logo-fc.png';
import logo2 from '../assets/img/logo-basf.png';
import logo3 from '../assets/img/logo-gea.png';
import logo4 from '../assets/img/logo-siemens.png';
import logo5 from '../assets/img/logo-vdl.png';
import logo6 from '../assets/img/logo-a-ware.png';
import logo7 from '../assets/img/logo-smurfit-kappa.png';
import logo8 from '../assets/img/logo-remia.png';
import logo9 from '../assets/img/logo-bosch.png';
import logo10 from '../assets/img/logo-demcon.png';
import logo11 from '../assets/img/logo-dero.png';
import logo12 from '../assets/img/logo-marel.png';
import logo13 from '../assets/img/logo-vmi.png';

import image1 from '../assets/img/img-block-1.webp';
import image2 from '../assets/img/img-block-2.webp';
import image3 from '../assets/img/img-block-3.webp';
import image4 from '../assets/img/img-block-4.webp';
import image5 from '../assets/img/img-block-5.webp';
import image6 from '../assets/img/img-block-6.webp';

export const logos = [
  {
    src: logo1,
    alt: 'Logo FC'
  },
  {
    src: logo2,
    alt: 'Logo BASF'
  },
  {
    src: logo3,
    alt: 'Logo GEA'
  },
  {
    src: logo4,
    alt: 'Logo Siemens'
  },
  {
    src: logo5,
    alt: 'Logo VDL'
  }
];

export const logosJobDetails = [
  {
    src: logo9,
    alt: 'Logo BOSCH'
  },
  {
    src: logo10,
    alt: 'logo demcon'
  },
  {
    src: logo11,
    alt: 'logo dero'
  },
  {
    src: logo12,
    alt: 'logo marel'
  },
  {
    src: logo13,
    alt: 'logo vmi'
  }
];

export const logosExpertise = [
  {
    src: logo6,
    alt: 'Logo A WARE'
  },
  {
    src: logo5,
    alt: 'Logo VDL'
  },
  {
    src: logo1,
    alt: 'Logo FC'
  },
  {
    src: logo7,
    alt: 'Logo SK'
  },
  {
    src: logo8,
    alt: 'Logo REMIA'
  }
];

export const slides = [
  {
    image: {
      src: image1,
      alt: 'Image 1'
    }
  },
  {
    image: {
      src: image2,
      alt: 'Image 2'
    }
  },
  {
    image: {
      src: image3,
      alt: 'Image 3'
    }
  },
  {
    image: {
      src: image4,
      alt: 'Image 4'
    }
  },
  {
    image: {
      src: image5,
      alt: 'Image 5'
    }
  },
  {
    image: {
      src: image6,
      alt: 'Image 6'
    }
  }
];
